import { atom, useAtom } from "jotai";
import { ViewModes } from "models/enumerations/view-modes/view-modes";

export const viewModeAtom = atom<ViewModes>(ViewModes.Grid);
const usePageViewSettings = () => {
    const [viewMode, setViewMode] = useAtom(viewModeAtom);
    return { viewMode, setViewMode };
};

export default usePageViewSettings;
